import { User } from '@alluradirect/react';
import { useRouter } from 'next/router';
import { LoginState, SignupSteps } from 'pages/signup';
import { useEffect, useMemo } from 'react';
import { toast } from 'react-toastify';
import { GuestRoutesEnum, OwnerRoutesEnum } from 'routes/routes';

//TODO: type userQuery correctly
export const useIsUserLoggedInRedirectToManagement = (userQuery: any, isHostLogin?: boolean) => {
  const hasHostProfile = function (user: User | false | undefined): user is User {
    return user !== undefined && (user as User).OWNER_PROFILE !== undefined;
  };
  const router = useRouter();

  const loginState: LoginState = useMemo(() => {
    if (!userQuery.data) return 'loading';
    if (!userQuery.data.DATA.USER) return 'notloggedin';
    return Object.keys(userQuery.data.DATA.USER).length > 0 ? 'loggedin' : 'notloggedin';
  }, [userQuery.data]);

  const isLoggedIn = loginState === 'loggedin';
  const hasIsHostLogin = typeof isHostLogin === 'boolean';
  const user = userQuery.data?.DATA?.USER;
  const profile_obj = hasHostProfile(user);
  const isHost = hasIsHostLogin ? (isHostLogin ? true : false) : Boolean(profile_obj);

  useEffect(() => {
    if (isLoggedIn) {
      toast.success('You are already logged in!');
      const path = isHost ? OwnerRoutesEnum.management : GuestRoutesEnum.home;
      router.replace({
        pathname: path,
        query: { ...router.query, [path]: '' },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userQuery]);
};

export const useIsUserLoggedInRedirectSignup = (userQuery: any, isHostLogin?: boolean) => {
  const hasHostProfile = function (user: User | false | undefined): user is User {
    return user !== undefined && (user as User).OWNER_PROFILE !== undefined;
  };

  const router = useRouter();
  const isFirstStep = Number(router.query?.step) === SignupSteps.CreateAccount;

  const loginState: LoginState = useMemo(() => {
    if (!userQuery.data) return 'loading';
    if (!userQuery.data.DATA.USER) return 'notloggedin';
    return Object.keys(userQuery.data.DATA.USER).length > 0 ? 'loggedin' : 'notloggedin';
  }, [userQuery.data]);

  const isLoggedIn = loginState === 'loggedin';
  const hasIsHostLogin = typeof isHostLogin === 'boolean';
  const user = userQuery.data?.DATA?.USER;
  const profile_obj = hasHostProfile(user);
  const isHost = hasIsHostLogin ? (isHostLogin ? true : false) : Boolean(profile_obj);

  useEffect(() => {
    if (isLoggedIn && isFirstStep) {
      toast.success('You are already logged in!');
      const path = isHost ? OwnerRoutesEnum.management : GuestRoutesEnum.home;
      router.replace({
        pathname: path,
        query: { ...router.query, [path]: '' },
      });
    }
  }, [isFirstStep, isHost, isLoggedIn, router]);
};

